import React from 'react';
import { components } from 'react-select';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
// import { Truncate } from './utils';

export { CheckboxOption, RadioOption } from './input-options';
export { ClearIndicator, DropdownIndicator, LoadingIndicator } from './indicators';

export var MultiValueRemove = function MultiValueRemove(props) {
  return React.createElement(
    components.MultiValueRemove,
    props,
    React.createElement(SelectClearIcon, {
      size: 'small',
      primaryColor: 'transparent',
      secondaryColor: 'inherit'
    })
  );
};
export var IndicatorSeparator = null;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/select/dist/esm/components/index.js
// module id = 274
// module chunks = 0